angular.module('impactx.util').service('NewWindowService', [
    'TranslationService',
    '$errorHandler',
    '$location',
    '$window',
    NewWindowService]);

function NewWindowService(TranslationService, $errorHandler, $location, $window) {

    function openNewWindow (url, target) {
        var newWin = $window.open(url, target);
        if(!newWin || newWin.closed || typeof newWin.closed=='undefined') {
            $errorHandler.showErrors([{error: TranslationService.get('popupBlockerWarning')}]);
        }
        return newWin;
    }

    function check () {
        var newWin = $window.open($location.absUrl());
        if(!newWin || newWin.closed || typeof newWin.closed=='undefined') {
            $errorHandler.showErrors([{error: TranslationService.get('popupBlockerWarning')}]);
            return false;
        }
        newWin.close();
        return true;
    }

    return {
        openNewWindow: openNewWindow,
        check: check
    }

}